import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { FlashService } from "../../../flash/flash.service";
import { ErrorService } from "../../../services/error.service";
import { ExitChecklistService } from "../../../services/exit-checklist.service";

@Component({
  selector: 'app-exit-checklist-hr',
  templateUrl: './exit-checklist-hr.component.html',
  styleUrls: ['./exit-checklist-hr.component.css']
})
export class ExitChecklistHrComponent implements OnInit {

  public form: FormGroup;
  currentUser;
  public fields: any[];
  
  tem: any;
  exp_ans = [];

  inValid: boolean = false;
  errors;
  params:any;
  showform; 
  public elementName = [];

  constructor(
    private service: ExitChecklistService,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private errorService: ErrorService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.spinnerService.show()
     /* Taking values from the url */
    this.route.params.subscribe(
      params => {
        this.params = params 
        this.spinnerService.hide()
      }
    );
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.fields = JSON.parse(sessionStorage.getItem("ques_hr"));
    
    this.form = new FormGroup({});
    this.fields.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));
        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });

    this.generateForm()
    this.get_answer()
  }

  getFields() {
    return this.fields;
  }

  answers:any[] = [];
  get_answer() {
    this.spinnerService.show()
    this.service.getAnswerExitChecklistHR(this.params.id).subscribe(
      (data) => {
        this.tem = data.body;
        this.answers = this.tem.questions;

        if(this.answers.length > 0){
          this.showform = false
        }else{
          this.showform = true
        }
        this.spinnerService.hide()
      },
      (err) => {
        this.spinnerService.hide()
        console.log("Get HR ExitChecklist Answer Error:", err);
      }
    );
  }

  onSubmit() {
    //body formation below
    this.exp_ans = [];

    let keys_data = Object.keys(this.form.value);
    let value_data = Object.values(this.form.value);

    keys_data.forEach((element, index) => {
      var item = this.fields.find((item) => item.name === element);
      if ((typeof value_data[index] === "object") === true) {
        let obj = value_data[index];

        var keys = Object.keys(obj);

        var filtered = keys.filter(function (key) {
          return obj[key];
        });

        this.exp_ans.push({ name:item.name, id: item.id, ans: filtered });
      } else {
        this.exp_ans.push({ name:item.name, id: item.id, ans: value_data[index] });
      }

      if(value_data[index] === undefined){
        return this.inValid = true
     }
    });

    this.inValid = false;
    
    let obj = Object.values(this.form.value);

   obj.forEach((formValue) => {
      if (formValue === "") {
        this.inValid = true;
      }
    });

    this.elementName = [];

    this.exp_ans.forEach(ele => {
      if(!ele.ans){
        this.elementName.push(ele.name);
      }
    });

    if(this.elementName.length){
      this.inValid = true;
    }
    
    const payload = {
      emp_id: this.params.id.toString(),
      data: this.exp_ans,
    };

    if(this.inValid === false) this.submitChecklistHR(payload)
  }

  submitChecklistHR(data){
    this.spinnerService.show()
    this.service.submitChecklistHR(data).subscribe(
      (data) => {
        this.spinnerService.hide();
        if (data.body["success"]) {
          this.flashService.show(data.body["message"], "alert-success");
          setTimeout(()=>{                         
            this.router.navigateByUrl("offboarding");
        }, 1600);

        } else {
          this.errors = data.body["result"];
          this.flashService.show(data.body["message"], "alert-success");
          setTimeout(()=>{                         
            this.router.navigateByUrl("offboarding");
        }, 1600);
          
        }
        this.spinnerService.hide()
      },
      (error) => {
        this.spinnerService.hide();
        this.errorService.errorHandling(error);
      }
    );
  }



  generateForm() {
    this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields)),
    });

    this.form = new FormGroup({});
    this.fields.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));
        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });
  }

  back(){
    this.router.navigate(['/offboarding'])
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/forms-view/exit-checklist-hr/exit-checklist-hr.component.ts